function About(){
    return (
        <div className ="about" id="home">
           <div className="card">
               <div className="card-content" ><br/><br /><h2 className="team">Our Development Team</h2><br /><br /></div>
           </div>
           <br/>
           <br />
           <div class="col-container">
                <div class="col">
                    <div class="card card1">
                        <img src="https://res.cloudinary.com/yash06/image/upload/v1607267303/nhxkrtmghxutmgr0kjc3.jpg" alt="Avatar" width="320px"/>
                        <div class="container">
                            <h4><b>John Doe</b></h4>
                            <p>Architect & Engineer</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                <div class="card card1">
                        <img src="https://res.cloudinary.com/yash06/image/upload/v1607267303/nhxkrtmghxutmgr0kjc3.jpg" alt="Avatar"  width="320px" />
                        <div class="container">
                            <h4><b>John Doe</b></h4>
                            <p>Architect & Engineer</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card card1">
                        <img src="https://res.cloudinary.com/yash06/image/upload/v1607267303/nhxkrtmghxutmgr0kjc3.jpg" alt="Avatar"  width="320px" />
                        <div class="container">
                            <h4><b>John Doe</b></h4>
                            <p>Architect & Engineer</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="card card1">
                        <img src="https://res.cloudinary.com/yash06/image/upload/v1607267303/nhxkrtmghxutmgr0kjc3.jpg" alt="Avatar"  width="320px" />
                        <div class="container">
                            <h4><b>John Doe</b></h4>
                            <p>Architect & Engineer</p>
                        </div>
                    </div>
                </div>
            </div>
      </div>
)
}
export default About;